import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Baby, Minus, Plus } from "lucide-react";

interface ChildrenSelectorProps {
  value: number;
  onChange: (value: number) => void;
  max?: number;
  disabled?: boolean;
  compact?: boolean;
}

export function ChildrenSelector({
  value,
  onChange,
  max = 10,
  disabled = false,
  compact = false,
}: ChildrenSelectorProps) {
  return (
    <div className={compact ? "flex items-center gap-2" : "space-y-2"}>
      {!compact && (
        <Label className="flex items-center gap-1.5 text-sm">
          <Baby className="w-4 h-4" />
          Dont enfants
        </Label>
      )}
      <div className="flex items-center gap-2">
        {compact && <Baby className="w-4 h-4 text-muted-foreground flex-shrink-0" />}
        <Button
          type="button"
          variant="outline"
          size="icon"
          className="h-10 w-10"
          disabled={disabled || value <= 0}
          onClick={() => onChange(Math.max(0, value - 1))}
        >
          <Minus className="w-4 h-4" />
        </Button>
        <span className="w-8 text-center font-semibold text-base">{value}</span>
        <Button
          type="button"
          variant="outline"
          size="icon"
          className="h-10 w-10"
          disabled={disabled || value >= max}
          onClick={() => onChange(Math.min(max, value + 1))}
        >
          <Plus className="w-4 h-4" />
        </Button>
        {compact && (
          <span className="text-xs text-muted-foreground">enfant{value !== 1 ? "s" : ""}</span>
        )}
      </div>
    </div>
  );
}
